export function getPossibleErrorMessage(error: any): object | null {
  if (!error) {
    return null
  } else if (typeof error === 'string') {
    return { message: error }
  } else if (typeof error === 'object') {
    const { name, message } = error

    if (!name && !message) {
      return null
    }

    const result: { name?: string; message?: string } = {}

    if (name) {
      result.name = name
    }

    if (message) {
      result.message = message
    }

    return result
  }
  return null
}
